module.exports = __webpack_public_path__ + "img/flower-cycle-plain-white.a9163ca3.svg";